module.exports = __webpack_public_path__ + "img/demo_0.12249f9f.jpg";